import { createSlice } from "@reduxjs/toolkit";

import { REDUCERS } from "../../constants";

import * as UploadApprovalThunks from "./thunks";

import {
    handlePendingRequestActions,
    handleFulfilledRequestActions
} from "./helpers";

const initialState = {
    status: "idle", // ["idle", "loading"]
    approvalType: null, // ["deny", "visuallyPublish", "fullyPublish"]
    currentRequestId: undefined,
    error: null
};

export const uploadApprovalSlice = createSlice({
    name: REDUCERS.UPLOAD_APPROVAL,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(UploadApprovalThunks.deny.pending, (state, action) => {
                state.approvalType = "deny";
                handlePendingRequestActions(state, action);
            })
            .addCase(UploadApprovalThunks.deny.fulfilled, (state, action) => {
                state.approvalType = null;
                handleFulfilledRequestActions(state, action);
            })
            .addCase(
                UploadApprovalThunks.visuallyPublish.pending,
                (state, action) => {
                    state.approvalType = "visuallyPublish";
                    handlePendingRequestActions(state, action);
                }
            )
            .addCase(
                UploadApprovalThunks.visuallyPublish.fulfilled,
                (state, action) => {
                    state.approvalType = null;
                    handleFulfilledRequestActions(state, action);
                }
            )
            .addCase(
                UploadApprovalThunks.fullyPublish.pending,
                (state, action) => {
                    state.approvalType = "fullyPublish";
                    handlePendingRequestActions(state, action);
                }
            )
            .addCase(
                UploadApprovalThunks.fullyPublish.fulfilled,
                (state, action) => {
                    state.approvalType = null;
                    handleFulfilledRequestActions(state, action);
                }
            );
    }
});

export { UploadApprovalThunks };

export default uploadApprovalSlice.reducer;
